import { User } from '@/types/User';
import { SyncLogLevel } from '@/utils/diagnostics/diagnostics.constants';
import { logTransport } from '@/utils/diagnostics/logTransport';

export const logInfo = (
  apiUrl: string,
  token: string,
  user: User | null,
  message: string,
  data: unknown
): void => {
  logMessage(apiUrl, token, user, message, 'info', data);
};

export const logError = (
  apiUrl: string,
  token: string,
  user: User | null,
  message: string,
  data: unknown
): void => {
  logMessage(apiUrl, token, user, message, 'error', data);
};

export const logWarning = (
  apiUrl: string,
  token: string,
  user: User | null,
  message: string,
  data: unknown
): void => {
  logMessage(apiUrl, token, user, message, 'warning', data);
};

export const logDebug = (
  apiUrl: string,
  token: string,
  user: User | null,
  message: string,
  data: unknown
): void => {
  logMessage(apiUrl, token, user, message, 'debug', data);
};

const logMessage = (
  apiUrl: string,
  token: string,
  user: User | null,
  message: string,
  level: SyncLogLevel,
  data: unknown
): void => {
  try {
    console.log(message, data);
    if (!apiUrl || !token) {
      return;
    }
    const context = logTransport.buildContext(apiUrl, token, user, null);
    logTransport.sendImmediate(context, message, level, data);
  } catch (error) {
    console.error('Error while logging message', error);
  }
};
